/* eslint-env node */

// Import all schema files
const organizationSchema = require('./organizationSchema.json');
const prescriptionServiceSchema = require('./prescriptionServiceSchema.json');
const consultationServiceSchema = require('./consultationServiceSchema.json');
const localBusinessSchema = require('./localBusinessSchema.json');
const faqSchema = require('./faq-schema.json');
const healthHubSchema = require('./health-hub-schema.json');
const pricingSchema = require('./pricing-schema.json');
const medicalCertificateServiceSchema = require('./medicalCertificateServiceSchema.json');
const treatmentSchema = require('./treatment-schema.json');

// Schema mapping object
const SCHEMA_MAP = {
    'organization': organizationSchema,
    'prescription': prescriptionServiceSchema,
    'consultation': consultationServiceSchema,
    'localBusiness': localBusinessSchema,
    'faq': faqSchema,
    'pharmacy': healthHubSchema,
    'pricing': pricingSchema,
    'medicalCertificate': medicalCertificateServiceSchema,
    'treatment': treatmentSchema
};

/**
 * Get schema data based on an array of schema keys
 * @param {string[]} schemaKeys - Array of schema keys to retrieve
 * @returns {Object[]} Array of schema objects
 */
const getSchemaData = (schemaKeys) => {
    if (!Array.isArray(schemaKeys)) {
        console.warn('getSchemaData: schemaKeys must be an array');
        return [];
    }

    const schemas = [];
    
    for (const key of schemaKeys) {
        if (SCHEMA_MAP[key]) {
            schemas.push(SCHEMA_MAP[key]);
        } else {
            console.warn(`getSchemaData: Schema not found for key "${key}". Available keys:`, Object.keys(SCHEMA_MAP));
        }
    }
    
    return schemas;
};

module.exports = {
    getSchemaData,
    SCHEMA_MAP
};